/**
 *
 * @param phone - phone number that comes in the format "(xxx) xxx-xxxx".
 * @returns - a string that only contains digits.
 */
export default function removePhoneNumberFormatting(phone: string): string {
  return phone.replace(/\D/g, "");
}
